import { render, staticRenderFns } from "./block-address.vue?vue&type=template&id=6edfb8a2&scoped=true&"
import script from "./block-address.vue?vue&type=script&lang=js&"
export * from "./block-address.vue?vue&type=script&lang=js&"
import style0 from "./block-address.vue?vue&type=style&index=0&id=6edfb8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edfb8a2",
  null
  
)

export default component.exports